<template lang="pug">
.online-reservation-schedule-tab(v-cloak)
  .box-header.register-header
    .d-flex.flex-row.align-items-center
      .title
        span.title-name オンライン面会スケジュール
      OnlineReservationScheduleHelp
      .mr-4
      //- select show target
      .table-select
        ReservationScheduleStatusSwitch(v-model="showSettingTable")
    .buttons
      span.group-label.align-self-center(v-if="groupUseType == 1") 利用者グループ
      select.input-select(v-if="groupUseType == 1" v-model="groupId" @change="changeGroup")
        option(v-for="option in residentGroupOptions" :value="option.value"
        :class="{ disable: disableMoveMonthButton }" :disabled="disableMoveMonthButton") {{ option.label }}

      button.btn.disable(v-if="disablePrevMonthButton || disableMoveMonthButton" type="button" disabled) ＜&nbsp;前の月
      button.btn(v-else type="button" @click="onPreviousMonth()") ＜&nbsp;前の月
      button.btn.disable(v-if="disableMoveMonthButton" @click="onTomonth()" type="button" disabled) 今月
      button.btn(v-else @click="onTomonth()" type="button") 今月
      button.btn.disable(v-if="disableMoveMonthButton" @click="onNextMonth()" type="button" disabled) 次の月&nbsp;＞
      button.btn(v-else @click="onNextMonth()" type="button") 次の月&nbsp;＞

  .box-body(style="padding: 0;")
    span.error-message {{ errorMessage }}
    .table-box(v-show="showSettingTable")
      ReservationScheduleSettingTable(v-model="schedules" height="calc(100vh - 286px)" :isLoading="isLoading" :targetDate="targetDate")
    .table-box(v-show="!showSettingTable")
      .error-message(v-show="isCreate == true") スケジュールが未設定の為、予約状況は表示されません
      ReservationScheduleStatusTable(v-show="isCreate == false" v-model="schedules" height="calc(100vh - 286px)" :isLoading="isLoading" :targetDate="targetDate")

  .box-footer.register-footer
    .buttons.m-0
      button.btn.register-btn(v-if="showSettingTable" @click="showMultipleInputModal" :class="{ 'disable': isLoading }" :disabled="isLoading") 一括設定
      button.btn.reset-btn(v-if="showSettingTable" @click="resetSchedules" :class="{ 'disable': isLoading }" :disabled="isLoading") 全て×にする
      button.btn.register-btn(v-if="showSettingTable && isCreate" @click="onSave()") 登録
      button.btn.register-btn(v-else-if="showSettingTable && !isCreate" @click="onUpdate()") 更新
      button.btn.cancel-btn(@click="gotoReservationList") キャンセル

  OkCancelModal(v-model="showRegisterModal" title="オンライン面会スケジュールを登録しますか？" @ok="registerShcedule")
  OkModal(v-model="showRegisterSuccessModal" title="登録に成功しました。" @ok="createView")

  OkCancelModal(v-model="showUpdateModal" title="オンライン面会スケジュールを更新しますか？" @ok="updateShcedule")
  OkModal(v-model="showUpdateSuccessModal" title="更新に成功しました。" @ok="createView")

  ReservationScheduleMultipleInputModal(ref="multipleInputModal" v-model="schedules" :minHour="minHour" :maxHour="maxHour" :minUnit="minUnit"
    :scheduleTemplates="scheduleTemplates" @onTemplateList="onTemplateList")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { tabIndexesStore } from "@/store/store";

import { Url } from "@/commons/constants/Url";
import { PcUrl } from "@/commons/constants/PcUrl";
import OnlineReservationSchedulesService, { OnlineReservationSchedulesModel, OnlineReservationSchedulesPostModel } from "@/commons/services/OnlineReservationSchedules";
import OnlineReservationSettingsService, { OnlineReservationSettingsGetModel, GroupUseType, CountType } from "@/commons/services/OnlineReservationSettings";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import ReservationsService, { ReservationsGetModel, ReservationType } from "@/commons/services/Reservations";
import { ReservationScheduleTemplateGetModel } from "@/commons/services/ReservationScheduleTemplates";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import ReservationScheduleStatusSwitch from "@/pc/basics/ReservationScheduleStatusSwitch.vue";
import ReservationScheduleSettingTable from "@/pc/containers/reservations/OnlineReservationScheduleSettingTable.vue";
import ReservationScheduleStatusTable from "@/pc/containers/reservations/OnlineReservationScheduleStatusTable.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import OnlineReservationScheduleHelp from "@/pc/basics/OnlineReservationScheduleHelp.vue";
import ReservationScheduleMultipleInputModal from "@/pc/components/modals/ReservationScheduleMultipleInputModal.vue";
import SystemError from "@/commons/models/SystemError";

/**
 * ### オンライン面会スケジュールタブコンポーネント
 */
@Component({
  components: {
    ReservationScheduleSettingTable,
    ReservationScheduleStatusTable,
    OkCancelModal,
    OkModal,
    PageLoading,
    ReservationScheduleStatusSwitch,
    OnlineReservationScheduleHelp,
    ReservationScheduleMultipleInputModal
  }
})
export default class OnlineReservationScheduleTab extends Vue {
  /** オンライン面会スケジュールサービス */
  @Inject("OnlineReservationSchedulesService") onlineReservationSchedulesService!: OnlineReservationSchedulesService;
  /** オンライン面会設定サービス */
  @Inject("OnlineReservationSettingsService") onlineReservationSettingsService!: OnlineReservationSettingsService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;
  /** 面会予約サービス(複数) */
  @Inject("ReservationsService") reservationsService!: ReservationsService;

  @Prop()
  scheduleTemplates!: Array<ReservationScheduleTemplateGetModel>;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 登録確認モーダル表示可否 */
  showRegisterModal: boolean = false;
  /** 登録完了モーダル表示可否 */
  showRegisterSuccessModal: boolean = false;
  /** 更新確認モーダル表示可否 */
  showUpdateModal: boolean = false;
  /** 更新完了モーダル表示可否 */
  showUpdateSuccessModal: boolean = false;

  /** 表示対象の選択肢 */
  showSettingTable: boolean = false;

  /** オンライン面会スケジュール */
  schedules: Array<Array<ReservationScheduleModel>> = [];
  /** オンライン面会スケジュール 読み込み状態 */
  isLoading: boolean = true;
  /** 現在表示している年月 */
  targetDate: Date = new Date();
  /** 訪問面会設定情報 */
  setting: OnlineReservationSettingsGetModel | null = null;
  /** 新規登録か否か */
  isCreate: boolean = true;
  /** 更新時に使用する整合性チェック用更新日時 */
  updated: number = 0;

  /** オンライン面会設定でグループを分けるか否か */
  groupUseType: GroupUseType = GroupUseType.DISUSE;
  /** グループ */
  groupId: number = 1;
  /** グループセレクトボックス用項目 */
  residentGroupOptions: Array<{ value: number | string; label: string }> = [];

  /** 一括登録モーダルの開始(時)選択肢 */
  minHour: number = 8;
  /** 一括登録モーダルの開始(分)選択肢 */
  maxHour: number = 18;
  /** 一括登録モーダルの終了(時)選択肢 */
  minUnit: number = 0;

  /** エラーメッセージ */
  errorMessage: string = "";

  get disablePrevMonthButton(): boolean {
    const today: Date = new Date();

    // 年が未来であれば非活性にならない
    if (today.getFullYear() < this.targetDate.getFullYear()) {
      return false;
    }
    // 年が同じであればかつ、月が未来であれば非活性にならない
    else if (today.getFullYear() == this.targetDate.getFullYear() && today.getMonth() < this.targetDate.getMonth()) {
      return false;
    }
    // その他であれば非活性(年が過去or同じ年かつ同じ月以下)
    else {
      return true;
    }
  }

  get disableMoveMonthButton(): boolean {
    return this.isLoading;
  }

  /**
   * ### vue lifecycle created
   *
   * - オンライン面会は面会予約の機能の一部だが、機能の仕様可否は別扱いになっている
   * - そのため、routerではなく個別にチェックしてNotFoundを返す必要がある
   */
  public created(): void {
    if (userStore.facility.permittedFunctions.onlineReservation == false) {
      this.$router.push(Url.NotFound);
      return;
    }
  }

  /**
   * ### vue lifecycle mounted
   *
   * - 初期表示では当月のオンライン面会スケジュールを表示する
   *   - 初期表示用の年月文字列を作成する
   * - this.targetDateの値を格納しなおすことで子コンポーネントに描画更新させる
   */
  public async mounted(): Promise<void> {
    const targetDate = new Date();
    targetDate.setDate(1);
    this.targetDate = targetDate;

    this.isLoading = true;

    // グループ毎にオンライン面会スケジュールを分けるか設定を取得する
    // 分ける場合は選択肢を用意するためにグループ情報を取得する
    const setting: OnlineReservationSettingsGetModel = await await this.onlineReservationSettingsService.get(userStore);
    this.setting = setting;
    this.groupUseType = setting.groupUseType;
    this.groupId = 1;

    if (this.groupUseType == GroupUseType.USE) {
      const residentGroups: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
      const residentGroupOptions: Array<{ value: number; label: string }> = this.createResidentGroupOptions(residentGroups);
      this.residentGroupOptions = residentGroupOptions;
    }

    // 一括登録モーダルで使用する情報を格納する
    this.minHour = 8;
    this.maxHour = 18;
    this.minUnit = setting.unit;

    this.isLoading = false;

    await this.createView();
    return;
  }

  /**
   * ### グループセレクトボックス用項目を作成する
   */
  public createResidentGroupOptions(residentGroups: Array<ResidentGroupsGetModel>): Array<{ value: number; label: string }> {
    const residentGroupOptions: Array<{ value: number; label: string }> = [];

    const allowedGroupsMap: Map<number, number> = new Map<number, number>();
    for (const allowedGroup of userStore.loginUser.permissions.residentGroups) {
      allowedGroupsMap.set(allowedGroup, allowedGroup);
    }
    for (const group of residentGroups) {
      if (allowedGroupsMap.has(group.id)) {
        residentGroupOptions.push({
          value: group.id,
          label: group.name
        });
      }
    }

    return residentGroupOptions;
  }

  /**
   * ### 画面表示情報作成
   *
   * - オンライン面会スケジュールを取得する
   *   - スケジュールが未登録の場合、初期データを作成する
   */
  public async createView(): Promise<void> {
    this.isLoading = true;

    this.errorMessage = "";
    const year: string = this.$dateUtil.convertDateToString(this.targetDate, "yyyy");
    const month: string = this.$dateUtil.convertDateToString(this.targetDate, "mm");

    // 面会予約を取得して、日時をkeyのmapにする
    // 仕様変更により「予約可能数のカウント範囲が施設全体の場合、予約は全利用者グループのスケジュールに「予約有」と反映させる」を満たすようにするMAPを作成する
    const reservations: Array<ReservationsGetModel> = await this.getReservations(year, month);
    const reservationsMap: Map<string, Array<ReservationsGetModel>> = new Map<string, Array<ReservationsGetModel>>();
    for (let reservation of reservations) {
      if (reservation.type == ReservationType.ONLINE) {
        const setting: OnlineReservationSettingsGetModel = this.setting as OnlineReservationSettingsGetModel;
        const mapReservations: Array<ReservationsGetModel> = reservationsMap.has(String(reservation.datetime))
          ? (reservationsMap.get(String(reservation.datetime)) as Array<ReservationsGetModel>)
          : [];

        if (setting.countType == CountType.FACILITY) {
          mapReservations.push(reservation);
          reservationsMap.set(String(reservation.datetime), mapReservations);
        } else if (setting.countType == CountType.GROUP && (!reservation.onlineReservationSchedulesSortKey || this.groupId == reservation.groupId)) {
          mapReservations.push(reservation);
          reservationsMap.set(String(reservation.datetime), mapReservations);
        }
      }
    }

    console.debug("this.groupId", this.groupId);
    console.debug("reservationsMap", reservationsMap);

    // オンライン面会スケジュールを作成する
    let schedules: Array<Array<ReservationScheduleModel>> = await this.createSchedules(year, month, reservationsMap, this.setting as OnlineReservationSettingsGetModel);
    this.isCreate = false;
    if (schedules.length < 1) {
      this.isCreate = true;
      schedules = this.createInitialSchedules(reservationsMap, this.setting as OnlineReservationSettingsGetModel);
    } else {
      this.isCreate = false;
      this.updated = schedules[0][0].updated;
    }
    this.schedules = schedules;
    this.isLoading = false;

    return;
  }

  /**
   * ### 訪問予約を取得する
   */
  public async getReservations(year: string, month: string): Promise<Array<ReservationsGetModel>> {
    let params: any = {};
    // 指定された年月の1日から最終日までの訪問予約を取得するため、パラメータを指定
    const start: number = this.$dateUtil.convertDateToNumber(new Date(), `${year}${month}01000000000`);
    const lastDay: number = new Date(Number(year), Number(month), 0).getDate();
    const end: number = this.$dateUtil.convertDateToNumber(new Date(), `${year}${month}${lastDay}235900000`);
    params = {
      start: start,
      end: end,
      sortKey: "datetime",
      order: "asc"
    };

    const response: Array<ReservationsGetModel> = await this.reservationsService.gets(userStore, params);

    return response;
  }

  /**
   * ### 画面表示用のオンライン面会スケジュールを作成
   *
   * - APIからオンライン面会スケジュールを取得する
   * - 取得した内容から画面でテーブル表示するための情報を作り直す
   * - 列が日、行が時になるように作り直す
   */
  public async createSchedules(
    year: string,
    month: string,
    reservationMap: Map<string, Array<ReservationsGetModel>>,
    setting: OnlineReservationSettingsGetModel
  ): Promise<Array<Array<ReservationScheduleModel>>> {
    this.isLoading = true;

    // 表示対象年月の最終日を求める
    let tempDate: Date = new Date(this.targetDate.getTime());
    tempDate.setMonth(tempDate.getMonth() + 1);
    tempDate.setDate(1);
    tempDate.setDate(tempDate.getDate() - 1);
    const lastDate: number = tempDate.getDate();

    let schedules: Array<Array<ReservationScheduleModel>> = [];

    // オンライン面会スケジュールを取得し、存在すれば使用する
    let reservationSchedules: Array<OnlineReservationSchedulesModel> = await this.getOnlineReservationSchedules(this.groupId, year, month);

    if (0 < reservationSchedules.length) {
      // 1次元目の配列は時間分 (24時間から0-7時と18-23時を除いた10時間分) 作成する
      schedules = new Array((24 - 14) * 4);
      for (let i = 0; i < (24 - 14) * 4; i++) {
        // 2次元目の配列は日数分作成する
        schedules[i] = new Array(lastDate);
      }

      // 2次元配列に情報を格納していく
      for (const schedule of reservationSchedules) {
        if (schedule.hour < 8 || schedule.hour >= 18) {
          continue;
        }
        const hourNo: number = (schedule.hour - 8) * 4;
        const minNo: number = schedule.min / 15;

        // mapから値取得用のkey作成
        const month: string = String(schedule.month).length == 1 ? "0" + String(schedule.month) : String(schedule.month);
        const date: string = String(schedule.date).length == 1 ? "0" + String(schedule.date) : String(schedule.date);
        const hour: string = String(schedule.hour).length == 1 ? "0" + String(schedule.hour) : String(schedule.hour);
        const min: string = String(schedule.min).length == 1 ? "0" + String(schedule.min) : String(schedule.min);

        // mapから値が取得できた場合は予約が入っているということなので、countを1にして予約済として扱わせる
        const reservations: Array<ReservationsGetModel> | undefined = reservationMap.get(`${schedule.year}${month}${date}${hour}${min}00000`);
        if (reservations != undefined) {
          schedule.reservationRequestsCount = reservations.length;
        }

        schedules[hourNo + minNo][schedule.date - 1] = Object.assign({}, { ...schedule, canReservationCount: setting.reservationPerCounts });
      }
    }

    return schedules;
  }

  /**
   * ### オンライン面会スケジュールを取得する
   */
  public async getOnlineReservationSchedules(groupId: number, year: string, month: string): Promise<Array<OnlineReservationSchedulesModel>> {
    const onlineReservationSchedules: Array<OnlineReservationSchedulesModel> = await this.onlineReservationSchedulesService.get(userStore, groupId, year, month);
    return onlineReservationSchedules;
  }

  /**
   * ### オンライン面会スケジュールの初期値を作成する
   *
   * - 取得した内容から画面でテーブル表示するための情報を作る
   * - 列が日、行が時になるように作り直す
   */
  public createInitialSchedules(reservationsMap: Map<string, Array<ReservationsGetModel>>, setting: OnlineReservationSettingsGetModel): Array<Array<ReservationScheduleModel>> {
    this.isLoading = true;

    // 年月は固定なので定義する
    const year: number = this.targetDate.getFullYear();
    const month: number = this.targetDate.getMonth() + 1;

    // 表示対象年月の最終日を求める
    let tempDate: Date = new Date(this.targetDate.getTime());
    tempDate.setMonth(tempDate.getMonth() + 1);
    tempDate.setDate(1);
    tempDate.setDate(tempDate.getDate() - 1);
    const lastDate: number = tempDate.getDate();

    // 1次元目の配列は時間分作成する
    let schedules: Array<Array<ReservationScheduleModel>> = new Array((24 - 14) * 4);
    for (let i = 0; i < (24 - 14) * 4; i++) {
      // 2次元目の配列は日数分作成する
      schedules[i] = new Array(lastDate);
      const hour: number = Math.floor(i / 4) + 8;
      const min: number = i * 15 - (hour - 8) * 60;

      for (let j = 0; j < lastDate; j++) {
        const date: number = j + 1;

        // mapから値が取得できた場合は予約が入っているということなので、countを1にして予約済として扱わせる
        let reservationRequestsCount: number = 0;
        const keyMonth: string = String(month).length == 1 ? "0" + String(month) : String(month);
        const keyDate: string = String(date).length == 1 ? "0" + String(date) : String(date);
        const keyHour: string = String(hour).length == 1 ? "0" + String(hour) : String(hour);
        const keyMin: string = String(min).length == 1 ? "0" + String(min) : String(min);
        const reservations: Array<ReservationsGetModel> | undefined = reservationsMap.get(`${year}${keyMonth}${keyDate}${keyHour}${keyMin}00000`);
        if (reservations != undefined) {
          reservationRequestsCount = reservations.length;
        }

        schedules[i][j] = {
          facilityId: userStore.facility.id,
          year: year,
          month: month,
          date: date,
          hour: hour,
          min: min,
          canReservation: false,
          canReservationCount: setting.reservationPerCounts,
          reservationRequestsCount: reservationRequestsCount,
          registerUserId: userStore.loginUser.userId,
          registerUserName: userStore.loginUser.name,
          deleteFlag: false,
          updated: this.updated
        };
      }
    }

    return schedules;
  }

  /**
   * ### グループ変更イベント処理
   */
  public async changeGroup(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 前の月ボタン押下イベント処理
   *
   * - 表示対象年月を1か月減算して画面表示を更新する
   * - this.targetDateの値を格納しなおすことで子コンポーネントに描画更新させる
   */
  public async onPreviousMonth(): Promise<void> {
    this.targetDate.setMonth(this.targetDate.getMonth() - 1);
    const newTargetDate = new Date(this.targetDate.getTime());
    newTargetDate.setDate(1);
    this.targetDate = newTargetDate;
    await this.createView();
    return;
  }

  /**
   * ### 当月ボタン押下イベント処理
   *
   * - 表示対象年月を現在年月にして画面表示を更新する
   * - this.targetDateの値を格納しなおすことで子コンポーネントに描画更新させる
   */
  public async onTomonth(): Promise<void> {
    const newTargetDate = new Date();
    newTargetDate.setDate(1);
    this.targetDate = newTargetDate;
    await this.createView();
    return;
  }

  /**
   * ### 次の月ボタン押下イベント処理
   *
   * - 表示対象年月を1か月加算して画面表示を更新する
   * - this.targetDateの値を格納しなおすことで子コンポーネントに描画更新させる
   */
  public async onNextMonth(): Promise<void> {
    this.targetDate.setMonth(this.targetDate.getMonth() + 1);
    const newTargetDate = new Date(this.targetDate.getTime());
    newTargetDate.setDate(1);
    this.targetDate = newTargetDate;
    await this.createView();
    return;
  }

  /**
   * ### 一括入力ダイアログを表示する
   */
  public showMultipleInputModal(): void {
    const modal: ReservationScheduleMultipleInputModal | Vue | Element | Vue[] | Element[] = this.$refs.multipleInputModal;
    if (modal instanceof ReservationScheduleMultipleInputModal) {
      modal.show();
    }
    return;
  }

  /**
   * ### スケジュールを全て×にする
   */
  public resetSchedules(): void {
    for (let i = 0; i < this.schedules.length; i++) {
      for (let j = 0; j < this.schedules[i].length; j++) {
        if (this.schedules[i][j].canReservation) {
          this.schedules[i][j].canReservation = false;
        }
      }
    }
    return;
  }

  /**
   * ### 登録ボタン押下イベント処理
   *
   * - オンライン面会スケジュール登録確認ダイアログを表示する
   */
  public onSave(): void {
    this.showRegisterModal = true;
    return;
  }

  /**
   * ### 登録確認ダイアログOKボタン押下イベント処理
   *
   * - APIにリクエストしてオンライン面会スケジュールを新規登録する
   */
  public async registerShcedule(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "登録中...";

    try {
      // 登録用情報を作成し、APIにリクエストを送る
      const requestBody: OnlineReservationSchedulesPostModel = this.createOnlineReservationSchedulesPostModel();

      const year: string = this.$dateUtil.convertDateToString(this.targetDate, "yyyy");
      const month: string = this.$dateUtil.convertDateToString(this.targetDate, "mm");
      await this.onlineReservationSchedulesService.post(userStore, this.groupId, year, month, requestBody);

      this.showRegisterSuccessModal = true;
    } catch (error) {
      // API Gatewayのタイムアウトが起きても無視するため、504以外が来たら例外を投げなおす
      const systemError: SystemError = error as SystemError;
      if (systemError.statusCode == 504) {
        setTimeout(() => {
          this.showRegisterSuccessModal = true;
        }, 10000);
      } else {
        throw error;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### APIリクエストするリクエストボディを作成する
   *
   * - 画面表示している情報は1次元目に時間、2次元目に日を持っている
   * - リクエストする場合は1次元目を日、2次元目を時間に入れ替えてリクエストする
   */
  public createOnlineReservationSchedulesPostModel(): OnlineReservationSchedulesPostModel {
    // 1次元目の配列は時間分 (24時間から0-7時と18-23時を除いた10時間分) 作成する
    let canReservations: Array<Array<boolean>> = new Array((24 - 14) * 4);

    for (let i = 0; i < (24 - 14) * 4; i++) {
      // 2次元目の配列は日数分作成する
      canReservations[i] = new Array(this.schedules[0].length);

      for (let j = 0; j < this.schedules[0].length; j++) {
        canReservations[i][j] = this.schedules[i][j].canReservation;
      }
    }

    // リクエストボディを作成する
    const onlineReservationSchedulesPostModel: OnlineReservationSchedulesPostModel = {
      canReservations,
      registerUserId: userStore.loginUser.userId,
      registerUserName: userStore.loginUser.name,
      updated: this.updated
    };

    return onlineReservationSchedulesPostModel;
  }

  /**
   * ### 更新ボタン押下イベント処理
   *
   * - オンライン面会スケジュール更新確認ダイアログを表示する
   */
  public onUpdate(): void {
    this.showUpdateModal = true;
    return;
  }

  /**
   * ### 更新確認ダイアログOKボタン押下イベント処理
   *
   * - APIにリクエストしてオンライン面会スケジュールを更新する
   */
  public async updateShcedule(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    try {
      // 登録用情報を作成し、APIにリクエストを送る
      const requestBody: OnlineReservationSchedulesPostModel = this.createOnlineReservationSchedulesPostModel();

      const year: string = this.$dateUtil.convertDateToString(this.targetDate, "yyyy");
      const month: string = this.$dateUtil.convertDateToString(this.targetDate, "mm");
      await this.onlineReservationSchedulesService.patch(userStore, this.groupId, year, month, requestBody);

      this.showUpdateSuccessModal = true;
    } catch (error) {
      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      const systemError: SystemError = error as SystemError;
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      }
      // API Gatewayのタイムアウト以外は上位に例外を投げなおす
      else if (systemError.statusCode == 504) {
        setTimeout(() => {
          this.showUpdateSuccessModal = true;
        }, 10000);
      } else {
        throw error;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 面会予約画面へ遷移する
   */
  public gotoReservationList(): void {
    this.$router.push(PcUrl.ReservationList);
    return;
  }

  /**
   * ### 面会スケジュールテンプレート一覧画面へ遷移する
   */
  public onTemplateList(): void {
    tabIndexesStore.setReservationSchedulesTabIndex({ index: 2 });
    this.$router.push(PcUrl.ReservationScheduleTemplateList);
    return;
  }
}

/** ### 画面表示用オンライン面会スケジュールモデル */
export interface ReservationScheduleModel extends OnlineReservationSchedulesModel {
  /** 予約空き数 */
  canReservationCount: number;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.online-reservation-schedule-tab {
  .box-header {
    padding: 10px 0;

    .title-name {
      margin-right: 6px;
    }

    .table-select {
      .register-radio-form {
        display: none;
      }
      .register-radio-label {
        margin: 0 8px 8px 0;
      }
      .register-radio-text {
        display: inline-block;
        margin: 0;
        padding: 6px 12px;
        @include font(18px);
        border-radius: 3px;
        transition: all 0.2s;
        border: 1px solid $form-border-color;
        background-color: $bg-default;
        cursor: pointer;

        &:hover {
          background: $list-hover;
        }
      }
      .register-radio-form:checked + .register-radio-text {
        background: $btn-selected;
        color: $btn-font-selected;
        border: 1px solid $btn-selected;
      }
    }

    .buttons {
      .group-label {
        @include bold-font(18px);
        margin: 0 6px 0 0;
      }
      .input-select {
        display: block;
        min-width: 320px;
        max-width: 320px;
        height: 42px;
        padding: 6px 12px;
        @include font(16px);
        background-color: $bg-default;
        border: 1px solid $form-border-color;
        border-radius: 0.25rem;
        &:focus {
          // chromeが自動的に付与するスタイルを無効化する
          outline: none;
          box-shadow: 0 0 0 0.2rem $form-boxshadow-select-color;
          border: 1px solid $form-border-select-color !important;
          border-radius: 0.25rem;
        }
      }

      .btn {
        width: 104px;
      }
    }
  }
  .box-footer {
    padding: 10px 0 0 0 !important;

    .register-btn,
    .cancel-btn {
      width: 120px;
    }
  }
}
</style>
